"use client";

import { useProgressRouter } from "@lib/util/navigation";
import FilterRadioGroup from "@modules/common/components/filter-radio-group";
import { usePathname, useSearchParams } from "next/navigation";
import { useCallback } from "react";

export type SortOptions = "price_asc" | "price_desc" | "created_at";

type SortProductsProps = {
  sortBy: SortOptions;
  // setQueryParams: (name: string, value: SortOptions) => void
  "data-testid"?: string;
};

const sortOptions = [
  {
    value: "created_at",
    label: "Mới nhất",
  },
  {
    value: "price_asc",
    label: "Giá tăng dần",
  },
  {
    value: "price_desc",
    label: "Giá giảm dần",
  },
];

const SortProducts = ({ "data-testid": dataTestId, sortBy }: SortProductsProps) => {
  const router = useProgressRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams);
      params.set(name, value);
      return params.toString();
    },
    [searchParams]
  );

  const handleChange = (value: SortOptions) => {
    const query = createQueryString("sortBy", value);
    router.push(`${pathname}?${query}`);
  };

  return (
    <FilterRadioGroup
      title="Sort by"
      items={sortOptions}
      value={sortBy}
      handleChange={handleChange}
      data-testid={dataTestId}
    />
  );
};

export default SortProducts;
